export const noOfSlides = 3
export const slidesInView = 1
export const slideHeight = '35px'
export const slideHeightMobile = '32px'
export const iterationTime = '10s'
export const timePerSlideInSec = 3
